import Swiper from "swiper";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

const featuredProductsCarousels = document.querySelectorAll(".featured-products-carousel");

featuredProductsCarousels.forEach(carousel => {
    const swiperHolderEl = carousel.querySelector(".swiper-holder");
    const swiperPaginationEl = carousel.querySelector(".swiper-pagination");
    const swiperEl = swiperHolderEl.querySelector(".swiper");
    const nextEl = swiperHolderEl.querySelector(".next");
    const prevEl = swiperHolderEl.querySelector(".prev");

    // Count the number of slides
    const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;

    // Determine breakpoints based on slide count
    let breakpoints;
    if (slideCount === 3) {
        breakpoints = {
            1024: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            },
        };
    } else {
        breakpoints = {
            1024: {
                slidesPerView: 2,
            },
            1440: {
                slidesPerView: 4,
            },
        };
    }

    const swiper = new Swiper(swiperEl, {
        modules: [Pagination, Autoplay, Navigation],
        watchOverflow: true,
        slidesPerView: 1,
        breakpoints: breakpoints,
        spaceBetween: 20,
        pagination: {
            el: swiperPaginationEl,
            type: "progressbar",
            clickable: true,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: {
            delay: 6000,
        },
        pauseOnMouseEnter: true,
        on: {
            init(sw) {
                if (this.slides.length === 1) {
                    swiperPaginationEl.style.display = "none";
                    nextEl.style.display = "none";
                    prevEl.style.display = "none";
                } else {
                    const totalSlides = sw.slides.length;
                    const slidesPerView = Math.max(1, sw.params.slidesPerView);
                    const totalPositions = Math.max(1, totalSlides - slidesPerView + 1);
                    const currentPosition = Math.min(sw.activeIndex + 1, totalPositions);
                    carousel.querySelector(".swiper-counter").innerHTML = `${currentPosition} / ${totalPositions}`;
                }
            },
            slideChangeTransitionEnd: function (sw) {
                const totalSlides = sw.slides.length;
                const slidesPerView = Math.max(1, sw.params.slidesPerView);
                const totalPositions = Math.max(1, totalSlides - slidesPerView + 1);
                const currentPosition = Math.min(sw.activeIndex + 1, totalPositions);
                carousel.querySelector(".swiper-counter").innerHTML = `${currentPosition} / ${totalPositions}`;
            }
        },
    });
});
